export const SIDEBAR_STATE_KEY = "hust_sidebar_state";
export const SIDEBAR_STATE_EVENT = "hust-sidebar-state-change";
export const SIDEBAR_COLLAPSED_COOKIE = "hust_sidebar_collapsed";

export const readSidebarCollapsed = () => {
  if (typeof window === "undefined") return false;

  const cookieEntry = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${SIDEBAR_COLLAPSED_COOKIE}=`));
  if (cookieEntry) return cookieEntry.endsWith("=1");

  try {
    return JSON.parse(window.localStorage.getItem(SIDEBAR_STATE_KEY) || "{}").collapsed === true;
  } catch {
    return false;
  }
};

export const writeSidebarCollapsed = (collapsed) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(
    SIDEBAR_STATE_KEY,
    JSON.stringify({ collapsed: Boolean(collapsed) }),
  );
  document.cookie = `${SIDEBAR_COLLAPSED_COOKIE}=${collapsed ? "1" : "0"}; max-age=31536000; path=/`;
  window.dispatchEvent(new Event(SIDEBAR_STATE_EVENT));
};

export const subscribeSidebarCollapsed = (onChange) => {
  if (typeof window === "undefined") return () => {};

  const sync = () => onChange(readSidebarCollapsed());
  window.addEventListener(SIDEBAR_STATE_EVENT, sync);
  window.addEventListener("storage", sync);

  return () => {
    window.removeEventListener(SIDEBAR_STATE_EVENT, sync);
    window.removeEventListener("storage", sync);
  };
};
